import type { JobChat, DirectChat } from '@th-types/inbox-reviews.type';

export const getJobChatId = (message: JobChat): number => message.chatId;

export const getDirectChatId = (message: DirectChat): number => message.chatId;
